
import { Component, Input } from '@angular/core';
import {
    ControlValueAccessor,
    DefaultValueAccessor,
    FormControl,
    FormGroup,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldAppearance, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ErrorFieldComponent } from '../error-field/error-field.component';

/**
 * @example
 *  <siat-textarea-field
 *    [formGroup]="formModificaStruttura"
 *    controlName="controlName"
 *    id="ID"
 *    name="Name"
 *    placeholder="Placeholder"
 *    label="Label"
 *    type="text"
 *  ></siat-textarea-field>
 */
@Component({
   
  selector: 'siat-textarea-field',
  templateUrl: './textarea-field.component.html',
  providers: [DefaultValueAccessor],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    ErrorFieldComponent,
    MatInputModule
],
})
export class TextareaFieldComponent implements ControlValueAccessor {
  /**
   * The form group associated with the textarea field.
   */
  @Input()
  formGroup: FormGroup;

  /**
   * The control name associated with the textarea field.
   */
  @Input()
  controlName: string;

  /**
   * The id attribute of the textarea field.
   */
  @Input() id?: string;

  /**
   * The textarea placeholder.
   */
  @Input()
  placeholder: string;

  /**
   * The textarea "name" attribute value.
   */
  @Input() name?: string;

  /**
   * The textarea "label" attribute value.
   */
  @Input() label?: string;

  /**
   * The rows of the textarea.
   */
  @Input() rows = 4;

  /**
   * The textarea appearance.
   */
  @Input()
  appearance: MatFormFieldAppearance = 'outline';

  /**
   * Gets the form control associated with the input field.
   */
  get control(): FormControl<string> {
    return this.formGroup.controls[this.controlName] as FormControl<string>;
  }

  /**
   * Gets a flag telling if the the form control is in a disabled state.
   */
  get disabled(): boolean {
    return this.control.disabled;
  }

  /**
   * @inheritdoc
   */
  onChange: (value: string) => void = () => {};

  /**
   * @inheritdoc
   */
  onTouched: (value: string) => void = () => {};

  /**
   * The write value function.
   */
  writeValue(obj: string): void {
    this.control.setValue(obj);
  }

  /**
   * The register on change function.
   */
  registerOnChange(onChangeCallBack: () => string): void {
    this.onChange = onChangeCallBack;
    this.control.valueChanges.subscribe(onChangeCallBack);
  }

  /**
   * The register on touched function.
   */
  registerOnTouched(onTouchedCallBack: () => string): void {
    this.onTouched = onTouchedCallBack;
  }
}
